import { render, staticRenderFns } from "./CancellationBanner.vue?vue&type=template&id=4aa3d85e&scoped=true"
import script from "./CancellationBanner.vue?vue&type=script&lang=js"
export * from "./CancellationBanner.vue?vue&type=script&lang=js"
import style0 from "./CancellationBanner.vue?vue&type=style&index=0&id=4aa3d85e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa3d85e",
  null
  
)

export default component.exports